import Actions from 'redux/actions'
import type { CallAPIAction, Status } from 'api/types'
import { FailResponse } from 'api/evisaAPI/dlAPI'

type State = { errorMessage?: string } & Status

const initialState = {
  isLoading: false,
  success: false,
  fail: false,
  errorMessage: '',
}

export default (
  state: State = initialState,
  action: CallAPIAction<
    Actions.REGISTER_CHANGE_MOBILE_ASYNC,
    Actions.REGISTER_CHANGE_MOBILE_SUCCESS,
    Actions.REGISTER_CHANGE_MOBILE_FAIL,
    {},
    FailResponse
  >,
): State => {
  switch (action.type) {
    case Actions.REGISTER_CHANGE_MOBILE_ASYNC:
    case Actions.REGISTER_CHANGE_MOBILE_SUCCESS: {
      return {
        ...state,
        ...action.status,
      }
    }
    case Actions.REGISTER_CHANGE_MOBILE_FAIL: {
      return {
        ...state,
        ...action.status,
        errorMessage: action.payload?.error.message || '',
      }
    }
    default:
      return state
  }
}
